module.exports = __webpack_public_path__ + "img/code-22.defd3bdc.png";